import { Component } from "react";
import { useLocation, Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

class ErrorBoundaryInner extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Route render error:", error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <section className="container-x py-32 text-center" data-testid="route-error">
          <div className="w-14 h-14 rounded-2xl bg-[#F59E0B]/10 text-[#F59E0B] grid place-items-center mx-auto mb-6">
            <AlertTriangle className="w-7 h-7" />
          </div>
          <h1 className="font-display text-3xl font-bold text-[#0F172A]">Something went wrong.</h1>
          <p className="text-slate-600 mt-4 max-w-md mx-auto leading-relaxed">
            This page ran into an unexpected error. Please try again or head back home.
          </p>
          <div className="mt-8 flex items-center justify-center gap-3">
            <button
              data-testid="route-error-retry"
              onClick={() => this.setState({ hasError: false })}
              className="btn-secondary"
            >
              Try again
            </button>
            <Link to="/" data-testid="route-error-home" className="btn-primary">
              Back to home
            </Link>
          </div>
        </section>
      );
    }
    return this.props.children;
  }
}

export default function ErrorBoundary({ children }) {
  const location = useLocation();
  return <ErrorBoundaryInner resetKey={location.pathname}>{children}</ErrorBoundaryInner>;
}
